import api from 'api'
import { ImpressaoComprovanteAgendamentoInput } from 'api/ImpressaoAgendamento'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { useCallback } from 'react'
import { formatNomeCidadao } from 'view/cidadao/utils-cidadao'

interface NomeCidadao {
  nome: string
  nomeSocial?: string
}

export function useImpressaoComprovanteAgendamento() {
  const { handleImpressaoPath, handleImpressaoError } = useHandleImpressao()

  const handleImpressaoComprovanteAgendamento = useCallback(
    (nomeCidadao: string | NomeCidadao, agendamentoId: ID | ReadonlyArray<ID>) => {
      const nomeCidadaoFormatado = typeof nomeCidadao === 'string' ? nomeCidadao : formatNomeCidadao(nomeCidadao)
      const agendamentosIds = Array.isArray(agendamentoId) ? agendamentoId : [agendamentoId]

      return handleImpressaoPath({
        apiPath: api.agendamento.gerarComprovanteAgendamento,
        values: { nomeCidadao: nomeCidadaoFormatado, agendamentosIds } as ImpressaoComprovanteAgendamentoInput,
        file: `${nomeCidadaoFormatado.titleCase().split(' ').slice(0, 2).join('_')}_comprovante_agendamento.pdf`,
      }).catch(handleImpressaoError)
    },
    [handleImpressaoError, handleImpressaoPath]
  )

  return { handleImpressaoComprovanteAgendamento }
}
